import { createFileRoute, Outlet } from '@tanstack/react-router';

// Passthrough layout — (pages)/index.tsx renders at /certified-materials/
export const Route = createFileRoute('/(client)/certified-materials/(pages)')({
  component: () => <Outlet />,
});
